'use strict'

import * as PrgConfig from '@/assets/javascript/PrgConfig-lib.js'
import differenceBy from 'lodash/differenceBy'

export const setPrograms = (socketData, store) => {

    if (socketData.type === 'Capabilities') {

        store.setData('capabilities', socketData.data.Capabilities)

    } else if (socketData.data.length > 0) { // there is program data in socket...

        // if (store.getData('programs') && store.getData('programs').length > 0) { // update socket if store has program data

        //  console.log('socketData.data: ', JSON.stringify(socketData.data[0]))

        //     socketData.data.forEach((program) => {

        //         const resultArray = store.getData('programs').filter((programCached) => programCached.ID === program.ID)
        //         // console.log(JSON.stringify(resultArray).substring(0, 195))

        //         if (!Array.isArray(resultArray)) return

        //         if (resultArray.length) {

        //             // hotfix: store data in global var to avoid being
        //             // overwritten by faulty socketdata sync
        //             let programStarts = window.programs[program.ID].starts ? window.programs[program.ID].starts : program.starts

        //             Object.assign(resultArray[0], program)
        //             Object.assign(resultArray[0].starts, programStarts)

        //             //Object.assign(program, resultArray[0]) // Existing program, save to socketData [Object.assign(target, source)]
        //         } else {
        //             store.getData('programs').push(program) // New Program (unused for now)
        //         }

        //         /*
        //         // earlier implementation, please keep for clarification
        //         resultArray.length
        //             ? Object.assign(program, resultArray[0]) // Existing program, updating
        //             : store.getData('programs').push(program) // New Program (unused for now)
        //         */
        //     })
        // } else {

            let socketDataManipulated = socketData.data

            // hotfix: store data in global var to avoid being
            // overwritten by faulty socketdata sync
            socketDataManipulated.forEach((element) => {
                let elID = element.ID
                if (window.programs[elID].starts) {
                    element.starts = window.programs[elID].starts
                }
            })

            store.setData('programs', socketDataManipulated)
        // }
    }

    store.getData('programs').forEach((program) => PrgConfig.addPrgConfig(program))
}

export const setStations = (socketData, store) => {
    let stations = socketData.data // Current list of running Stations
    let storedStations = store.getData('stations') // Stored list of stations

    // console.log(JSON.stringify(stations))

    if (Array.isArray(stations)) {
        if (storedStations.length === 0 || (store.data.controller.group && store.data.controller.group == 'TWC')) { // First list, setting data
            store.setData('stations', stations)
        } else { // This is an update to the current list set above
            // Turn off all stations that are not part of update
            let runningList = storedStations.filter(station => station.isRunning || station.runningEntries.length > 0)
            let stationsToTurnOff = differenceBy(runningList, stations, 'StId')

            stationsToTurnOff.forEach(station => {
                station.runningEntries = []
                station.isRunning = false
                station.stStat = "Passive"
            })

            stations.forEach(stationUpdate => {
                const stationMatch = storedStations.find(station => station.StId === stationUpdate.StId)
                // @TODO: boo bad, @FIXME: should be fixed on the server
                delete stationUpdate.name
                delete stationUpdate.description
                delete stationUpdate.expectedFlow
                delete stationUpdate.precip
                delete stationUpdate.status
                if (stationMatch) {
                    Object.assign(stationMatch, stationUpdate)
                }
            })
        }
    } else {
        console.warn(`stations: expected array got ${typeof stations}`, JSON.stringify(stations, null, 2))
    }
}

export const setUser = (socketData, store) => {
    store.setData('user', Object.assign({}, store.getData('user'), socketData.data.record[0]))

    const permissions = socketData.data.record[0]

    const permid = parseInt(permissions.permid, 10)
    const permList = {
        ngwi: [1, 4, 5, 6, 7],
        jTurf: [1, 3, 4, 5, 7],
        virtualControl: [1, 3, 4, 5, 7],
        wheel: [1, 4, 5, 7],
        programEdit: [1, 4, 5, 7],
        stationEdit: [1, 4, 5, 7],
        sensorDecoderEdit: [1, 4, 5, 7],
        sync: [1, 4, 5, 7]
    }
    let access = {}

    Object.keys(permList).forEach((key) => {
        access[key] = permList[key].includes(permid)
    })

    store.setData('user.access', access)
}

export const setMain = (socketData, store) => {
    if (socketData.data.controllerMode) {
        // ET & Rain
        store.setData('dailyEt', parseInt(socketData.data.daily_et, 10))
        store.setData('dailyRain', parseInt(socketData.data.daily_rain, 10))
        store.setData('hourlyRain', parseInt(socketData.data.hourly_rain, 10))
        // Electrical
        store.setData('current', parseInt(socketData.data.current, 10))
        store.setData('voltage', parseInt(socketData.data.voltage, 10))
        // Flow
        store.setData('currentFlow', parseInt(socketData.data.currentFlow, 10))
        store.setData('expectedFlow', parseInt(socketData.data.expectedFlow, 10))


        // set systemCapacity based on controller group type - jimm 10.feb.21
        let sysCap = parseInt(socketData.data.systemCapacity, 10)
        store.setData('systemCapacity',
            (store.data.controller.group && store.data.controller.group == 'TWC') ? (sysCap / 10) : sysCap
        )
        // store.setData('systemCapacity', parseInt(socketData.data.systemCapacity, 10))

        store.setData('controller.mode', parseInt(socketData.data.controllerMode, 10))

        // Water Consumption
        if (socketData.data.waterConsumption !== '') {
            store.setData('waterConsumption', socketData.data.waterConsumption)
        }
        // Rainshutdown
        store.setData('rainShutDownTime', store.getData('controller.clientModifiedTime'))
        store.setData('rainShutDown.time', parseInt(socketData.data.rainShutDown, 10))
        // Moisture @FIXME: @TODO: Workaround as MoistCurrent is handled in update flow, but shouldn't 7/5/20
        if (socketData.data.MoistCurrent && socketData.data.MoistCurrent.list && socketData.data.MoistCurrent.list.length) {
            if (Object.keys(socketData.data.MoistCurrent.list[0]).length)
                store.setData('moisture', socketData.data.MoistCurrent)
        }
    }
}

export const setFlow = (socketData, store) => {
    store.setData('current', parseInt(socketData.data.current, 10))
    store.setData('voltage', parseInt(socketData.data.voltage, 10))
    store.setData('currentFlow', parseInt(socketData.data.currentFlow, 10))
    store.setData('expectedFlow', parseInt(socketData.data.expectedFlow, 10))
}

export const setElectricFlow = (socketData, store) => {
    store.setData('currentFlow', parseInt(socketData.data.currentFlow, 10))
    store.setData('expectedFlow', parseInt(socketData.data.expectedFlow, 10))
    // set systemCapacity based on controller group type - jimm 10.feb.21
    let sysCap = parseInt(socketData.data.systemCapacity, 10)
    store.setData('systemCapacity',
        (store.data.controller.group && store.data.controller.group == 'TWC') ? (sysCap / 10) : sysCap
    )
    // store.setData('systemCapacity', parseInt(socketData.data.systemCapacity, 10))
    store.setData('current', parseInt(socketData.data.current, 10))
    store.setData('voltage', parseInt(socketData.data.voltage, 10))
}

export const setServerTimeout = (socketData, store) => {
    const codeSplit = socketData.data.code.split(':')
    const code = codeSplit[0]
    const time = parseInt(codeSplit[1])

    const clientModifiedTime = store.getData('controller.clientModifiedTime')

    if (code !== 'I20' || clientModifiedTime === null) return

    store.setData('controller.clientTimeoutTime', clientModifiedTime + time * 1000)

    if (time === 720) store.setData('controller.clientTimeoutStartTime', clientModifiedTime)
}

export const setSystemCapabilities = (socketData, store) => {
    if (socketData.data.Capabilities) {
        store.setData('systemCapabilities', socketData.data.Capabilities)
    }
}